import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\PriceController::index
* @see app/Http/Controllers/Admin/PriceController.php:28
* @route '/admin/prices'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/prices',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PriceController::index
* @see app/Http/Controllers/Admin/PriceController.php:28
* @route '/admin/prices'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PriceController::index
* @see app/Http/Controllers/Admin/PriceController.php:28
* @route '/admin/prices'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PriceController::index
* @see app/Http/Controllers/Admin/PriceController.php:28
* @route '/admin/prices'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PriceController::create
* @see app/Http/Controllers/Admin/PriceController.php:103
* @route '/admin/prices/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/prices/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PriceController::create
* @see app/Http/Controllers/Admin/PriceController.php:103
* @route '/admin/prices/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PriceController::create
* @see app/Http/Controllers/Admin/PriceController.php:103
* @route '/admin/prices/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PriceController::create
* @see app/Http/Controllers/Admin/PriceController.php:103
* @route '/admin/prices/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PriceController::store
* @see app/Http/Controllers/Admin/PriceController.php:135
* @route '/admin/prices'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/prices',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\PriceController::store
* @see app/Http/Controllers/Admin/PriceController.php:135
* @route '/admin/prices'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PriceController::store
* @see app/Http/Controllers/Admin/PriceController.php:135
* @route '/admin/prices'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PriceController::edit
* @see app/Http/Controllers/Admin/PriceController.php:221
* @route '/admin/prices/{price}/edit'
*/
export const edit = (args: { price: number | { id: number } } | [price: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/admin/prices/{price}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PriceController::edit
* @see app/Http/Controllers/Admin/PriceController.php:221
* @route '/admin/prices/{price}/edit'
*/
edit.url = (args: { price: number | { id: number } } | [price: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { price: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { price: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            price: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        price: typeof args.price === 'object'
        ? args.price.id
        : args.price,
    }

    return edit.definition.url
            .replace('{price}', parsedArgs.price.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PriceController::edit
* @see app/Http/Controllers/Admin/PriceController.php:221
* @route '/admin/prices/{price}/edit'
*/
edit.get = (args: { price: number | { id: number } } | [price: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PriceController::edit
* @see app/Http/Controllers/Admin/PriceController.php:221
* @route '/admin/prices/{price}/edit'
*/
edit.head = (args: { price: number | { id: number } } | [price: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PriceController::update
* @see app/Http/Controllers/Admin/PriceController.php:265
* @route '/admin/prices/{price}'
*/
export const update = (args: { price: number | { id: number } } | [price: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/prices/{price}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\PriceController::update
* @see app/Http/Controllers/Admin/PriceController.php:265
* @route '/admin/prices/{price}'
*/
update.url = (args: { price: number | { id: number } } | [price: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { price: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { price: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            price: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        price: typeof args.price === 'object'
        ? args.price.id
        : args.price,
    }

    return update.definition.url
            .replace('{price}', parsedArgs.price.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PriceController::update
* @see app/Http/Controllers/Admin/PriceController.php:265
* @route '/admin/prices/{price}'
*/
update.put = (args: { price: number | { id: number } } | [price: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

const prices = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
}

export default prices